import { Message, Thread } from 'app/messages/message-service/message.model';
import { Borrower } from 'lendio-borrower/models/borrower/borrower.model';

export class UnsetActiveUserThread {
  static readonly type = '[UserThreads] UnsetActiveUserThread';
  constructor() {}
}

export class GetUserThreads {
  static readonly type = '[UserThreads] GetUserThreads';
  constructor(
    public lenderUserId: number,
    public reset: boolean = true,
    public page: number = 1,
    public filterBy: string = 'unread',
    public sortDirection: string = 'desc',
  ) {}
}

export class GetThread {
  static readonly type = '[UserThreads] GetThread';
  constructor(
    public threadId: number,
    public filterUnread?: boolean,
  ) {}
}

export class MarkMessageAsRead {
  static readonly type = '[UserThreads] MarkMessageAsRead';
  constructor(
    public message: Message
  ) {}
}

export class AddBorrowerToThread {
  static readonly type = '[UserThreads] AddBorrowerToMessage';
  constructor(public borrower: Borrower, public threadId: number) {}
}

export class MarkThreadUnread {
  static readonly type = '[UserThreads] MarkThreadRead';
  constructor(
    public threadId: number,
  ) {}
}

export class SetActiveThread {
  static readonly type = '[UserThreads] SetActiveThread';
  constructor(
    public activeThread: Thread,
  ) {}
}
